import { render, staticRenderFns } from "./logisticsDistribution.vue?vue&type=template&id=6bb1bac0&scoped=true"
import script from "./logisticsDistribution.vue?vue&type=script&lang=js"
export * from "./logisticsDistribution.vue?vue&type=script&lang=js"
import style0 from "./logisticsDistribution.vue?vue&type=style&index=0&id=6bb1bac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb1bac0",
  null
  
)

export default component.exports